import { AttendanceAction } from '@/services/api/attendance-activity-api.ts';
import { AttendanceWithApprovalsDto } from '@/services/api/attendance-day-api.ts';
import { useApi } from '@/composables/use-api.ts';
import dayjs from 'dayjs';
import { EmployeeWithOrganizationDto } from '@/services/api/employee-api.ts';

export function calExtraWorkTime(item: AttendanceWithApprovalsDto | undefined) {
  if (!item) return 0;
  if (item.holiday == 'Y') return 0;

  return item.workExtraDayTime + item.workExtraNightTime;
}

export function calNightWorkTime(item: AttendanceWithApprovalsDto | undefined) {
  if (!item) return 0;
  if (item.holiday == 'Y') return 0;

  const workNightTime = item.workAfterNightTime + item.workMorningNightTime;
  return workNightTime - item.workExtraNightTime;
}

export function calHolidayWorkTime(
  item: AttendanceWithApprovalsDto | undefined
) {
  if (!item) return 0;
  if (item.holiday == 'N') return 0;

  return item.workTime;
}

enum ActionName {
  WORK_START = '근무 시작',
  WORK_END = '근무 종료',
  AWAY_START = '자리비움 시작',
  AWAY_END = '자리비움 종료',
}

export function toActionName(action: AttendanceAction) {
  switch (action) {
    case 'WORK_START':
      return ActionName.WORK_START;
    case 'WORK_END':
      return ActionName.WORK_END;
    case 'AWAY_START':
      return ActionName.AWAY_START;
    case 'AWAY_END':
      return ActionName.AWAY_END;
    default:
      return 'unknown action';
  }
}

export async function getAttendanceMissingAsync(deadlineDate: string) {
  const { attendance } = useApi();
  const ym = dayjs(deadlineDate).format('YYYY-MM');
  const date = dayjs(deadlineDate);

  const items = (await attendance.day.listMissingAttendancesAsync(ym)).filter(
    (item) => !dayjs(item.date).isAfter(date)
  );

  items.push(...(await attendance.day.listMissingApplicationsAsync(ym)));
  items.sort((a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf());
  return items;
}

export interface AttendanceItem {
  employee: EmployeeWithOrganizationDto;
  attendance?: AttendanceWithApprovalsDto;
  status?: string;
}

export async function getAttendanceSearchItemAsync(
  employee: EmployeeWithOrganizationDto,
  date: string
): Promise<AttendanceItem> {
  const { attendance } = useApi();
  const item = await attendance.day.getAsync(employee.no, date);
  if (!item)
    return {
      employee: employee,
    };

  async function getStatusAsync(item: AttendanceWithApprovalsDto) {
    if (item.vacationType == 'ALL') return '전일휴가';
    else if(item.vacationType == 'MORNING') return '오전휴가';
    else if(item.vacationType == 'AFTERNOON') return '오후휴가';

    const activities = (
      await attendance.activity.listByAttendanceIdAsync(item.id)
    ).filter((activity) => activity.location);
    if (activities && activities.length != 0) {
      const activity = activities.reduce((_, c) => c);
      if (activity?.location == 'INSIDE') return '사무실';
      if (activity?.location == 'OUTSIDE') return '외근';
      if (activity?.location == 'HOME') return '재택';
    }
    return '';
  }

  return {
    employee: employee,
    attendance: item,
    status: await getStatusAsync(item),
  };
}
